import { IconProps } from '@app/components/Atoms/Icon'
import React from 'react'

export const SummaryIcon: React.FC<IconProps> = ({ active, onClick, className, ...rest }) => {
  return (
    <svg
      {...rest}
      className={className}
      onClick={onClick}
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M30.3437 11.9565H15.7549V15.3745H30.3437V11.9565Z"
        fill={active ? '#0B2948' : '#FBFBFB'}
      />
      <path
        d="M30.3437 18.0557H15.7549V21.5366H30.3437V18.0557Z"
        fill={active ? '#0B2948' : '#FBFBFB'}
      />
      <path
        d="M30.3437 24.3828H15.7549V27.8008H30.3437V24.3828Z"
        fill={active ? '#0B2948' : '#FBFBFB'}
      />
      <path
        d="M11.9433 16.0741C13.2064 16.0741 14.2304 15.0501 14.2304 13.787C14.2304 12.5239 13.2064 11.5 11.9433 11.5C10.6802 11.5 9.65625 12.5239 9.65625 13.787C9.65625 15.0501 10.6802 16.0741 11.9433 16.0741Z"
        fill="#61C9DC"
      />
      <path
        d="M11.9433 22.1727C13.2064 22.1727 14.2304 21.1488 14.2304 19.8857C14.2304 18.6226 13.2064 17.5986 11.9433 17.5986C10.6802 17.5986 9.65625 18.6226 9.65625 19.8857C9.65625 21.1488 10.6802 22.1727 11.9433 22.1727Z"
        fill="#61C9DC"
      />
      <path
        d="M11.9433 28.4999C13.2064 28.4999 14.2304 27.4759 14.2304 26.2128C14.2304 24.9497 13.2064 23.9258 11.9433 23.9258C10.6802 23.9258 9.65625 24.9497 9.65625 26.2128C9.65625 27.4759 10.6802 28.4999 11.9433 28.4999Z"
        fill="#61C9DC"
      />
    </svg>
  )
}

export default SummaryIcon
